import React from "react";

const GrandPatron = () => (
  <>
    <div className="col-md-12">
      <div className="dlab-box m-b30 team-1">
        <div
          className="dlab-media"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <img
            src="/assets/images/patrons/tinubu.jpeg"
            alt="Tinubu"
            style={{ height: "270px", objectFit: "contain" }}
          />
        </div>
        <div className="p-a10">
          <h4 className="dlab-title text-uppercase">
            President BOLA AHMED TINUBU
          </h4>
          <p className="dlab-member-position">
            The President, Federal Republic of Nigeria His Excellency, President
            Bola Ahmed Tinubu, GCFR, GCON.
          </p>
        </div>
      </div>
    </div>
  </>
);

export default GrandPatron;
